// frontend/src/api/apiFunction/paymentServices.js

import { httpGet, httpPost } from "../../utils/httpMethods";
import { PAYMENT_URL, SUBSCRIPTION_URL } from "../restEndpoint";

//  NEW DUAL PROVIDER FUNCTIONS

// Create subscription checkout (supports both Tap and Stripe)
export const createSubscriptionCheckout = async (
  planId,
  userId,
  referralId = null,
  paymentProvider = "tap",
  billingCycle = "monthly"
) => {
  const payload = {
    planId,
    userId,
    billingCycle,
    paymentProvider,
  };
  if (referralId) {
    payload.referralId = referralId;
  }
  return httpPost({
    url: `${SUBSCRIPTION_URL}/checkout`,
    payload,
  });
};

// Verify subscription payment (auto-detects provider from charge ID)
export const verifySubscriptionPayment = async (chargeId, provider = null) => {
  let params = {};

  // Auto-detect provider from charge ID format if not specified
  if (!provider) {
    if (chargeId.startsWith("chg_")) {
      params.tap_id = chargeId;
    } else if (chargeId.startsWith("cs_") || chargeId.startsWith("pi_")) {
      params.stripe_id = chargeId;
    } else {
      // Fallback - try as tap_id first
      params.tap_id = chargeId;
    }
  } else {
    // Use specified provider
    if (provider === "tap") {
      params.tap_id = chargeId;
    } else if (provider === "stripe") {
      params.stripe_id = chargeId;
    }
    params.provider = provider;
  }

  return httpGet({
    url: `${SUBSCRIPTION_URL}/verify`,
    params,
  });
};

// Get available payment providers
export const getPaymentProviders = async () => {
  return httpGet({
    url: `${SUBSCRIPTION_URL}/providers`,
  });
};

// Get recommended payment provider based on country
export const getRecommendedPaymentProvider = (countryCode) => {
  const gccCountries = ["OM", "AE", "SA", "KW", "BH", "QA"];
  return gccCountries.includes(countryCode) ? "tap" : "stripe";
};

//  LEGACY TAP-ONLY FUNCTIONS (for backward compatibility) 

// Create a Tap checkout session (legacy)
export const createCheckoutSession = async (
  planId,
  userId,
  referralId = null
) => {
  const payload = { planId, userId };
  if (referralId) {
    payload.referralId = referralId;
  }
  return httpPost({
    url: `${PAYMENT_URL}/checkout-session`,
    payload,
  });
};

// Verify a Tap checkout session (legacy)
export const verifyCheckoutSession = async (tapId) => {
  return httpGet({
    url: `${PAYMENT_URL}/verify-session`,
    params: { tap_id: tapId },
  });
};
